var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscordNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_459_9724",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 0H0V35H36.1667V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_459_9724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2492 0H9.91585C4.76119 0 0.58252 4.17867 0.58252 9.33333V25.6667C0.58252 30.8213 4.76119 35 9.91585 35H26.2492C31.4039 35 35.5825 30.8213 35.5825 25.6667V9.33333C35.5825 4.17867 31.4039 0 26.2492 0Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2491 0.583984H9.91577C5.08327 0.583984 1.16577 4.50149 1.16577 9.33398V25.6673C1.16577 30.4998 5.08327 34.4173 9.91577 34.4173H26.2491C31.0816 34.4173 34.9991 30.4998 34.9991 25.6673V9.33398C34.9991 4.50149 31.0816 0.583984 26.2491 0.583984Z",
    stroke: "white",
    strokeOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3075 10.3713C24.7875 9.73204 23.1417 9.2681 21.4274 9.00005C21.4124 8.99961 21.3974 9.00216 21.3836 9.0075C21.3698 9.01285 21.3574 9.02086 21.3474 9.03098C21.1417 9.3712 20.9017 9.81452 20.7417 10.1547C18.9233 9.90731 17.0741 9.90731 15.2558 10.1547C15.0958 9.80421 14.8558 9.3712 14.6386 9.03098C14.6272 9.01036 14.5929 9.00005 14.5586 9.00005C12.8443 9.2681 11.21 9.73204 9.67849 10.3713C9.66706 10.3713 9.65563 10.3816 9.6442 10.3919C6.53555 14.588 5.67838 18.6706 6.10125 22.7121C6.10125 22.7327 6.11268 22.7533 6.13554 22.7636C8.19274 24.1245 10.1699 24.9493 12.1243 25.4957C12.1586 25.506 12.1928 25.4957 12.2043 25.4751C12.6614 24.9081 13.0729 24.3101 13.4272 23.6812C13.45 23.64 13.4272 23.5987 13.3815 23.5884C12.73 23.3616 12.1128 23.0935 11.5071 22.7843C11.4614 22.7636 11.4614 22.7018 11.4957 22.6708C11.6214 22.5884 11.7471 22.4956 11.8728 22.4131C11.8957 22.3925 11.93 22.3925 11.9528 22.4028C15.8844 24.0214 20.1245 24.0214 24.0103 22.4028C24.0332 22.3925 24.0675 22.3925 24.0903 22.4131C24.216 22.5059 24.3417 22.5884 24.4675 22.6812C24.5132 22.7121 24.5132 22.7739 24.456 22.7946C23.8617 23.1142 23.2332 23.3719 22.5817 23.5987C22.536 23.609 22.5246 23.6606 22.536 23.6915C22.9017 24.3204 23.3132 24.9184 23.7589 25.4854C23.7932 25.4957 23.8274 25.506 23.8617 25.4957C25.8275 24.9493 27.8047 24.1245 29.8619 22.7636C29.8848 22.7533 29.8962 22.7327 29.8962 22.7121C30.3991 18.0417 29.0619 13.99 26.3532 10.3919C26.3418 10.3816 26.3304 10.3713 26.3075 10.3713ZM14.0215 20.248C12.8443 20.248 11.8614 19.2686 11.8614 18.0624C11.8614 16.8561 12.8214 15.8767 14.0215 15.8767C15.2329 15.8767 16.193 16.8664 16.1815 18.0624C16.1815 19.2686 15.2215 20.248 14.0215 20.248ZM21.9874 20.248C20.8102 20.248 19.8273 19.2686 19.8273 18.0624C19.8273 16.8561 20.7874 15.8767 21.9874 15.8767C23.1989 15.8767 24.1589 16.8664 24.1475 18.0624C24.1475 19.2686 23.1989 20.248 21.9874 20.248Z",
    fill: "#B3B3B3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordNav);
export default __webpack_public_path__ + "static/media/discordNav.0663d9b1bb359c33bd2bb2daae1fbbda.svg";
export { ForwardRef as ReactComponent };